import { HttpErrorResponse } from '@angular/common/http';
import { ClientError } from '../types';

export function isHttpErrorResponse(error: HttpErrorResponse | any): error is HttpErrorResponse {
  return (error as HttpErrorResponse)?.name === 'HttpErrorResponse';
}

export function isClientError(error: ClientError | any): error is ClientError {
  return (error as ClientError).isClientError === true;
}
